import { gql } from '@apollo/client';

export const GET_WORKERS = gql`
  query workers {
    workers(first: 100) {
      data {
        id
        uuid
        last_name
        first_name
      }
    }
  }
`;

export const WORK_SHIFTS_REPORT = gql`
  query workShiftsReport($input: WorkShiftsReport!) {
    workShiftsReport(input: $input) {
      labels
      extraLabels
      extraLabels2
      extraLabels3
      keys

      data {
        values
      }
    }
    workShiftsSummaryReport(input: $input) {
      labels
      extraLabels
      extraLabels2
      extraLabels3
      keys

      data {
        values
      }
    }
  }
`;

export const WORK_SHIFTS_REPORT_EXPORT = gql`
  query workShiftsReportFile($input: WorkShiftsReport!) {
    workShiftsReport(input: $input) {
      url
      labels
      extraLabels
      extraLabels2
      extraLabels3
      keys

      data {
        values
      }
    }
  }
`;
export const WORK_SHIFTS_SUMMARY_REPORT_EXPORT = gql`
  query workShiftsSummaryReportFile($input: WorkShiftsReport!) {
    workShiftsSummaryReport(input: $input) {
      url
      labels
      extraLabels
      extraLabels2
      extraLabels3
      keys

      data {
        values
      }
    }
  }
`;

export const GET_WORK_SHIFT_BY_ID = gql`
  query workShift($id: Int!) {
    workShift(id: $id) {
      id
      worker {
        uuid
        first_name
        last_name
        roles {
          alias
        }
      }
      created_at
      finished_at
      money {
        cash_on_start
        sum {
          cash
          card
          deposit
          bonus
        }
      }
      payments {
        id
        method
        sum
        card_sum
        cash_sum
        created_at
        is_refunded
        client {
          uuid
          nickname
          phone
        }
        items {
          id
          amount
          type
          sum
          entity {
            ... on Service {
              id
              title
              cost
              vat
              tax_system
            }
            ... on Good {
              id
              title
              cost
              amount
              vat
              tax_system
            }
            ... on Tariff {
              id
              title
            }
          }
        }
      }
      cashOrders {
        type
        sum
      }
    }
  }
`;

export const GET_WORKSHIFT_DATA = gql`
  query workshiftData($id: Int!) {
    getWorkShiftPaymentOverviewData(id: $id) {
      id
      total
      cash
      card
      deposit
      online_deposit
      bonus
      cash_on_start
      created_at
      finished_at
      sum {
        good
        service
        tariff
        deposit
        tips
      }
      cash_orders {
        type
        comment
        created_at
        sum
      }
      worker {
        uuid
        first_name
        last_name
      }
      goods {
        title
        cost
        amount
        in_stock
        sum
      }
      services {
        title
        amount
        sum
      }
      combos {
        title
        amount
        sum
      }
    }
    workShift(id: $id) {
      comment
    }
  }
`;
